import React from 'react';
import { useTranslation } from 'react-i18next';
import RankingsTable from '../tables/RankingsTable';

const RankingsPage = ({ rankings, currentLanguage }) => {
  const { t } = useTranslation();

  return (
    <div className="content-section" key={`rankings-section-${currentLanguage}`}>
      <h2>{t('rankings.title')}</h2>
      <div className="rankings-section">
        {rankings.length > 0 && (
          <RankingsTable 
            rankings={rankings} 
            currentLanguage={currentLanguage} 
            key={`rankings-table-wrapper-${currentLanguage}`}
          />
        )}
      </div>
    </div>
  );
};

export default RankingsPage;
